var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import axios from "axios";
import { clone } from "ramda";
import { baseUrl } from "../index";
import { formatISO, subWeeks } from "date-fns";
import { removeUTCMinusThree, TWO_YEARS_IN_WEEKS } from "../../index";
function prepareUrl(options) {
  let url = baseUrl;
  url = url.replace(":company_id", options.companyId);
  return "".concat(url, "/reports");
}
export function setParams(params, axiosConfig) {
  const {
      created_since,
      created_until
    } = params,
    restOfParams = __rest(params, ["created_since", "created_until"]);
  axiosConfig.params = Object.assign(Object.assign({}, axiosConfig.params), restOfParams);
  axiosConfig.params.created_since = removeUTCMinusThree(formatISO(created_since ? new Date(created_since) : subWeeks(new Date(), TWO_YEARS_IN_WEEKS)));
  axiosConfig.params.created_until = removeUTCMinusThree(formatISO(created_until ? new Date(created_until) : new Date()));
}
export default (axiosConfig, options) => {
  return (params, exportOptions) => {
    const config = clone(axiosConfig);
    config.url = prepareUrl(options);
    setParams(params, config);
    config.data = exportOptions;
    config.method = "POST";
    return axios(config);
  };
};